import { Box, IconButton, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from "@mui/material"

import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom";

import useInternalFetch from "../../../api/apiInternal"

import DeleteIcon from '@mui/icons-material/Delete';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import PaidIcon from '@mui/icons-material/Paid';

import Loading from "../../../components/Loading"
import Subscribe from "../views/Subscribe"
import ConfirmDialog from "../../../components/ConfirmDialog";
import moment from "moment";
import config from "../../../common/Config";

const SubscriptionList = () => {

	const [subscriptions, setSubscriptions]			= useState()
	const [subscriptionId, setSubscriptionId]		= useState()
	const [isLoading, setIsLoading]					= useState(true)
	const [isConfirmOpen, setIsConfirmOpen]			= useState(false)

	const statusColors = [
		{ status : 'Em Análise', color : 'orange' },
		{ status : 'Ativo', color : 'green' },
		{ status : 'Cancelado', color : 'red' },
		{ status : 'Falha', color : 'red' }
	]
		
	const internalFetch								= useInternalFetch()
	const navigate									= useNavigate()
	
	useEffect(() => {
		handleLoading()
	}, [])

	const handleLoading = () => {
		setIsLoading(true)
		internalFetch(config.apiUrl +'/subscription')
		.then(results => {
			if (results.success) {
				setSubscriptions(results.data)
			}
			setIsLoading(false)
		})
	}

	const handleCancel = (pId) => {
		setSubscriptionId(pId)
		setIsConfirmOpen(true)
	}

	const cancelSubscription = () => {
		const options = {
			method : "DELETE",
			headers : {
				"Content-Type" : "application/json"	
			}
		}

		internalFetch(config.apiUrl +'/subscription/'+ subscriptionId, options)
		.then(() => {
			handleLoading()
			navigate('/subscription', { state : { returnMessage: 'Assinatura cancelada com sucesso!' }})
		})
	}

	if (isLoading) return <Loading/>

	return (
		subscriptions?.length > 0 ? (
			<TableContainer component={Box}>
				<ConfirmDialog
					title="Cancelar Assinatura?"
					open={isConfirmOpen}
					setOpen={setIsConfirmOpen}
					onConfirm={cancelSubscription}
					>
					Tem certeza que deseja cancelar sua Assinatura?
				</ConfirmDialog>
				<Table sx={{ minWidth: 650 }} aria-label="simple table">
					<TableHead>
					<TableRow>
						<TableCell>Tipo</TableCell>
						<TableCell align="center">Cartão</TableCell>
						<TableCell align="center">Peridiciodade</TableCell>
						<TableCell align="center">Assinante desde</TableCell>
						<TableCell align="center">Situação</TableCell>
						<TableCell align="center">Valido até</TableCell>
						<TableCell align="center">Ações</TableCell>
					</TableRow>
					</TableHead>
					<TableBody>
					{subscriptions.map((row) => (
						<TableRow
							key={row.id}
							sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
							>
							<TableCell component="th" scope="row">{row.type === 'SUBSCRIPTION' ? 'Assinatura Básica' : 'Canal' }</TableCell>
							<TableCell align="center">{row.cardNumber}</TableCell>
							<TableCell align="center">{row.interval === 'year' ? 'Anual' : 'Mensal'}</TableCell>
							<TableCell align="center">{moment(row.createdAt).format('DD/MM/YYYY')}</TableCell>
							<TableCell align="center" sx={{color: statusColors.find(sc => sc.status === row.status)?.color}}>{row.status}</TableCell>
							<TableCell align="center">{row.validUntil ? moment(row.validUntil).format('DD/MM/YYYY') : '-'}</TableCell>
							<TableCell align="center">
									{row.status === 'Cancelado' ? (
										<Tooltip title="Reativar Assinatura">
											<IconButton onClick={() => navigate('/subscription/new', { state : { start_at : moment(row.validUntil).add(1, 'd').toISOString() } })}>
												<PaidIcon sx={{fontSize: '1rem', color: 'green'}}/>
											</IconButton>
										</Tooltip>
									) : (
										<Stack direction={'row'} sx={{justifyContent: 'center'}}>
											<Tooltip title="Alterar Cartão de Crédito">
												<IconButton onClick={() => navigate('/subscription/'+ row.id)}>
													<CreditCardIcon sx={{fontSize: '1rem'}}/>
												</IconButton>
											</Tooltip>
											<Tooltip title="Cancelar Assinatura">
												<IconButton onClick={() => handleCancel(row.id)}>
													<DeleteIcon sx={{fontSize: '1rem'}}/>
												</IconButton>
											</Tooltip>
										</Stack>
									)}
							</TableCell>
						</TableRow>
					))}
					</TableBody>
				</Table>
			</TableContainer>
		) : (
			<Subscribe />
		)
	)
}

export default SubscriptionList